import { render, staticRenderFns } from "./PublicRoleCard.vue?vue&type=template&id=f4f4b882&scoped=true&"
import script from "./PublicRoleCard.vue?vue&type=script&lang=ts&"
export * from "./PublicRoleCard.vue?vue&type=script&lang=ts&"
import style0 from "./PublicRoleCard.vue?vue&type=style&index=0&id=f4f4b882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f4b882",
  null
  
)

export default component.exports